import {
  CompanyInfoFormDataType,
  CreatePasswordFormDataType,
  PersonalInfoFormDataType
} from 'models/get-started.model';
import { createContext, useContext } from 'react';

export type LetsGetStartedContextType = {
  personalInfoFormData: PersonalInfoFormDataType;
  setPersonalInfoFormData: (item: PersonalInfoFormDataType) => void;
  companyInfoFormData: CompanyInfoFormDataType;
  setCompanyInfoFormData: (item: CompanyInfoFormDataType) => void;
  passwordFormData: CreatePasswordFormDataType;
  setPasswordFormData: (item: CreatePasswordFormDataType) => void;
  disabled: boolean;
  setDisabled: (value: boolean) => void;
};
export const LetsGetStartedContext = createContext({} as LetsGetStartedContextType);

const useLetsGetStartedContext = () => {
  const context = useContext(LetsGetStartedContext);
  return context;
};

export default useLetsGetStartedContext;
